import React, { useRef } from 'react';

import UserForm from './Forms/UserForm';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function AddEditUserModal({
  open,
  type = 'add',
  handleClose,
  handleSubmit,
  transitionDuration = 220,
  actionsDisabled,
  user,
  rolesData = {},
  companyType,
}) {
  const userFormRef = useRef(null);

  const headerOptions = {
    add: `Add new user`,
    edit: `Edit user`,
  };
  const okBtnText = {
    add: 'Create',
    edit: 'Update',
  };

  if (!~['add', 'edit'].indexOf(type)) return null;

  return (
    <div>
      <Dialog
        open={open}
        transitionDuration={transitionDuration}
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            p: 1,
            pb: 2,
            justifyContent: 'center',
            alignItems: 'center',
            width: '440px',
          },
        }}
      >
        <DialogTitle>{headerOptions[type] || ''}</DialogTitle>
        <DialogContent>
          <UserForm
            roles={rolesData?.roles || []}
            accesses={rolesData?.accesses || []}
            ref={userFormRef}
            onSubmit={(values) => handleSubmit(values)}
            defaultValues={user}
            companyType={companyType}
          />
        </DialogContent>
        <DialogActions
          style={{ justifyContent: 'space-between', width: '60%' }}
        >
          <Button
            style={{ width: '100%', marginRight: '8px' }}
            variant="outlined"
            onClick={handleClose}
            disabled={actionsDisabled}
          >
            Cancel
          </Button>
          <Button
            style={{ width: '100%' }}
            variant="contained"
            disabled={actionsDisabled}
            onClick={() => userFormRef.current?.requestSubmit()}
            endIcon={
              actionsDisabled ? (
                <CircularProgress color="inherit" size={'1rem'} />
              ) : null
            }
          >
            {okBtnText[type]}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
